/* eslint-disable global-require */
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row, Image, Container, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import { getCookies } from "../../hooks/useCookies";
import { TableContext } from "../../contexts/tableContext";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import styles from "./viewPopup.module.scss";
import { DateFormatter } from "../../utilityFunctions/utilsFunctions";
import envValues from "../../enviornment";
import { Entry } from "../../redux/entrySlice";
import { useDispatch } from "react-redux";
import Loader from "../../components/Loader/Loader";
import PropTypes from "prop-types";

const ViewFeedbackPopup = React.memo(({ feedbackId, handleClose, setIsUpdated }) => {
  const { dashboardStyle } = useContext(TableContext);
  const { formthemeStyle, bodyheader, viewformStyle } =
    useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);
  const dispatch = useDispatch();
  const params = useParams();
  const token = `Bearer ${getCookies("Token")}`;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const dateFormat = getCookies("dateFormat");
  const [adminReply, setAdminReply] = useState("");
  const [replyError, setReplyError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  let statusCode;
  const getUserDetails = async () => {
    setLoading(true);
    axios
      .get(`${envValues.REACT_APP_API_ENDPOINT}/feedback/${feedbackId}`, {
        method: "GET",
        headers: { Authorization: token },
      })
      .then((resp) => {
        statusCode = resp.status;
        return resp.data;
      })
      .then((res) => {
        if (statusCode === 200) {
          console.log("res.data.user", res.data.feedback);
          setDetails(res.data.feedback);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    getUserDetails();
  }, []);

  const handleReplyChange = (e) => {
    const value = e.target.value;
    setAdminReply(value);
    
    // Clear error when user starts typing
    if (replyError && value.trim()) {
      setReplyError("");
    }
  };

  const validateReply = () => {
    if (!adminReply.trim()) {
      setReplyError("Admin reply is required");
      return false;
    }
    return true;
  };

  const handleSubmitReply = async (e) => {
    e.preventDefault();
    
    if (!validateReply()) {
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.patch(
        `${envValues.REACT_APP_API_ENDPOINT}/feedback/${feedbackId}/reply`,
        { adminReply: adminReply.trim() },
        {
          headers: { Authorization: token },
        }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Reply sent successfully");
        setAdminReply("");
        setReplyError("");
        if (setIsUpdated) {
          setIsUpdated(prev => !prev);
        }
        handleClose();
      }
    } catch (error) {
      console.error("Error sending reply:", error);
      toast.error(error?.response?.data?.message || "Failed to send reply");
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div className={styles.popupbox}>
      <div className={styles[formthemeStyle]} id={styles.box}>
        <span
          className={styles.closeicon}
          role="button"
          tabIndex={0}
          onClick={handleClose}
          onKeyPress={handleClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </span>
        {loading ? (
          <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "300px", // adjust height as needed
            width: "100%",
          }}
        >
          <Loader />
        </div>
        ) : (
          <Container fluid>
            {/* <FontAwesomeIcon
              icon={faArrowLeft}
              value="Back"
              onClick={() => {
                navigate(-1);
              }}
              className={styles.arrowback}
            /> */}
            <Row>
              <h5 className={styles[bodyheader]} id={styles.addheading}>
                Feedback Details
              </h5>
              <Col lg={12}>
                <div className={styles.profilepicdiv}>
                  {details.image ? (
                    <Image
                      src={details.image}
                      alt="logo"
                      className={styles.profilepic}
                    />
                  ) : (
                    <div>{details.name}</div>
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col lg={12} md={12} sm={12}>
                <div className={styles.detaildiv}>
                  <Row>
                    <Col lg={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Name</span>
                        <p className={styles.empname}>{details?.user?.name}</p>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Email</span>
                        <p className={styles.empname}>
                          {details?.user?.email ?? "NA"}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Category</span>
                        <p className={styles.empname}>
                          {details?.category ?? "NA"}
                        </p>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Description</span>
                        <p className={styles.empname}>
                          {details?.description ?? "NA"}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Posted On</span>
                        <p className={styles.empname}>
                          {details?.createdAt
                            ? DateFormatter(
                                details?.createdAt,
                                dateFormat || "MonthDayYear"
                              )
                            : "NA"}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  {/* Admin Reply Section */}
                  {details?.isReplied && details?.adminReply ? (
                    <Row className="mt-3">
                      <Col lg={12}>
                        <div className={styles[viewformStyle]} id={styles.empdiv} style={{ height: "auto", minHeight: "55px" }}>
                          <span className={styles.title}>Admin Reply</span>
                          <p className={styles.empname} style={{ whiteSpace: "pre-wrap" }}>
                            {details.adminReply}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    !details?.isReplied && (
                      <Row className="mt-4">
                        <Col lg={12}>
                          <h6 className="mb-3" style={{ fontWeight: "600" }}>Send Reply</h6>
                          <Form onSubmit={handleSubmitReply}>
                            <Form.Group className="mb-3">
                              <Form.Label>Admin Reply <span style={{ color: "red" }}>*</span></Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={4}
                                placeholder="Enter your reply to the user..."
                                value={adminReply}
                                onChange={handleReplyChange}
                                isInvalid={!!replyError}
                                disabled={submitting}
                                style={{ resize: "vertical" }}
                              />
                              <Form.Control.Feedback type="invalid">
                                {replyError}
                              </Form.Control.Feedback>
                            </Form.Group>
                            <div className="d-flex justify-content-end gap-2">
                              <Button
                                variant="secondary"
                                onClick={handleClose}
                                disabled={submitting}
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="primary"
                                type="submit"
                                disabled={submitting}
                                style={{ backgroundColor: "#39979d", borderColor: "#39979d" }}
                              >
                                {submitting ? "Sending..." : "Send Reply"}
                              </Button>
                            </div>
                          </Form>
                        </Col>
                      </Row>
                    )
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    </div>
  );
});

ViewFeedbackPopup.propTypes = {
  feedbackId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleClose: PropTypes.func.isRequired,
  setIsUpdated: PropTypes.func,
};

ViewFeedbackPopup.defaultProps = {
  setIsUpdated: null,
};

export default ViewFeedbackPopup;
